import { v4 as uuidv4 } from 'uuid';
import NotificationConstants from './NotificationConstants';
import {CheckCircleIcon, XCircleIcon} from "@heroicons/react/outline";
import React from "react";

const addNotification = (notification) => ({
    type: NotificationConstants.NOTIFICATION_ADDED,
    payload: notification
});

const removedNotification = (notificationId) => ({
    type: NotificationConstants.NOTIFICATION_REMOVED,
    payload: {
        id: notificationId,
    }
});

export const successNotification = title => createNotification(
    title,
    <CheckCircleIcon className="h-6 w-6 text-green-400" />
);

export const failureNotification = title => createNotification(
    title,
    <XCircleIcon className="h-6 w-6 text-red-400" />
);

export function createNotification(title, icon, timeout = 5000) {
    return function (dispatch) {
        const id = uuidv4();

        setTimeout(() => dispatch(removeNotification(id)), timeout);

        return dispatch(addNotification({
            id: id,
            title: title,
            icon: icon
        }));
    };
}

export function removeNotification(notificationId) {
    return function (dispatch) {
        return dispatch(removedNotification(notificationId));
    }
}
